import { Checkbox } from '@gov-design-system-ce/react-form';
import { useLocale } from '@gov-nx/core/service';
import { useMojeSouborySeznamContext } from '@gov-nx/module/page';

export const SelectAll = () => {
	const {
		code,
		myFilesSelection: { isAllSelected, isPartialySelected, toggleSelectAll },
	} = useMojeSouborySeznamContext();
	const { t } = useLocale(code);

	return (
		<div className="relative top-auto right-auto w-(--height-m-nudge) h-(--height-m-nudge)">
			<div className="relative -mt-[10px]!">
				<Checkbox
					name="selectAll"
					size="m"
					isChecked={isAllSelected}
					onChange={(e) => toggleSelectAll(e.target.checked)}
					indeterminate={isPartialySelected}
					hasNoLabel={true}
					aria-label={
						isAllSelected ? t('vyber.zrusit-vyber') : t('vyber.vybrat-vse')
					}
				/>
			</div>
		</div>
	);
};
